import React from "react";

const AimsObjectiveContainer = () => {
  return (
    <div className="flex flex-col gap-5 w-[694px] px-2">
      <div className="flex flex-col gap-4">
        <h1 className="text-[28px] font-semibold border-b-[1px] border-gray-400">
          Aims and Objectives
        </h1>
        <p className="text-[15px] font-medium">
          {" "}
          India has made progress in terms of increasing primary education
          attendance rate and expanding literacy to approximately three-fourths
          of the population. India's improved education system is often cited as
          one of the main contributors to the economic rise of India. However,
          India continues to face stern challenges. Despite growing investment
          in education, 25% of its population is still illiterate; only 15% of
          the students reach high school, and just 7% graduate. The situation at
          senior/ higher secondary education is still disheartening. The quality
          of education is significantly poor as compared with major developing
          nations. It is also not possible for the government alone to create
          infrastructure for the growing number of students at secondary and
          senior secondary level. With a mission to provide relevant continuing
          education at school stage, up to pre-degree it is, therefore,
          important to open school with public-private partnership. The
          organization has been carrying out some research work also over the
          last 3-4 years. With the aim and objective of enhancing and
          accelerating the enrolment/ retention at secondary and senior/
          secondary level, Council for Secondary and Senior Secondary Education
          (CSSE) was conceived and has been set up as an autonomous registered
          body under the Societies Registration Act, with its registered office
          at Delhi with the following objectives: To provide secondary and
          senior secondary education those belonging to disadvantaged groups
          (e.g. the Scheduled Castes, the Scheduled Tribes, Socially and
          Educationally disadvantaged classes and other socially, culturally,
          economically, geographically sections of the society, or such other
          factors as may be specified/ notified by the appropriate Government)
          and people belonging to weaker sections who are not able to get
          secondary and senior secondary education in the normal course of life.
          To provide professional services to the government and other agencies
          in the field of education, in general, and school education, in
          particular, for the development and growth of distance and open school
          system and develop appropriate curriculum for vocational and
          continuing education to prepare student population for the world of
          work. To provide the best possible teaching/ learning environment to
          its students, so that they can serve the society effectively and with
          dignity individualized study with flexibility in terms of place and
          duration. To identify educational needs of the children/persons of the
          State who are otherwise not catered to by the formal system of school
          education and to open study/academic centers. To provide opportunities
          for school education up to pre-degree level through Open and Distance
          Learning (ODL) mode, to identify and promote standards of learning in
          Open and Distance Learning system. To design and develop courses,
          self-instructional materials (SIM) and other learning support for the
          courses identified at different points of time, to organize
          orientation and training programmes for the functionaries of the open
          schooling system in the country, to evolve strategies for curriculum
          development, instructional procedures etc.; To undertake and
          coordinate educational research and programmes on the suggestion of
          the State government(s) concerned etc.; To establish contacts with
          international agencies in the field of education, specially school
          education, for keeping itself acquainted with the latest trends in
          curriculum development, material production, media use for
          dissemination etc, to establish links with other examining bodies with
          special focus on Asian countries; To collaborate with other agencies
          within and outside the state for developing and delivering skill
          oriented courses of study, to promote and publicize open schooling
          programmes and activities in the country. To maintain standards and
          equivalence with formal education system, while ensuring flexible
          characteristics of Open and Distance Learning System, to assist and
          advise the State Government in matters related to open schooling. To
          serve as an agency for effective dissemination of information related
          to open learning and distance education and to discharge coordination
          and clearing house functions To provide opportunities for continuing
          education to those who have missed opportunities to complete school
          and development education; and other children/persons desirous of
          pursuing school level education through Open and Distance Learning
          (ODL) mode by offering courses and programmes of general education,
          life enrichment and vocational education up to pre-degree level. To
          provide secondary and senior secondary education those who are
          belonging to disadvantaged groups (e.g. the Scheduled Castes, the
          Scheduled Tribes, Socially and Educationally backward classes and
          other groups having disadvantage owing to social, cultural, economic,
          geographical, linguistic, gender or such other factor as may be
          specified by the appropriate Government, notification) and the people
          belonging to weaker section are not able to get routine, secondary and
          senior secondary education. To provide professional services to the
          government and other agencies in the field of education, in general,
          and school education, in particular, for the development and growth of
          distance and open school system and develop appropriate curriculum for
          vocational and continuing education to prepare student population for
          the world of work. To establish linkages with contemporary education
          systems like State Boards, Sanskrit Boards, Madrasa Boards and state
          open boards with mainstream education system with mobility across them
          and equivalence between them;To expand access to school education at
          all levels and to increase retention rates at all levels of schooling.
          To encourage, promote and conduct a system of Open School Education
          relevant to the students/ learners, to organize training programmes at
          national and international level on `open school system; To promote
          interaction and co-ordination among open schools to make study of
          various subjects more purposeful and to effect a fusion between
          traditional and modern system of education; To institute career
          oriented courses related to education through distance learning/
          correspondence courses; to develop courses of education in various
          subjects. To remove the obstacles for providing secondary and senior
          secondary education to the disadvantaged sections of the society and
          to bring disadvantaged groups in the fold of mainstream of secondary/
          senior secondary education, to provide facilities for studies and
          research in Indian classical languages; To develop as a centre of
          excellence in the field of teaching, training and research related to
          literature and allied branches of knowledge in various languages; To
          establish/ affiliate schools for study of literature and allied
          branches of knowledge; to conduct examinations at secondary/senior
          secondary levels as per the guidelines laid down, to develop courses
          of instruction related to various languages and sciences up to
          Secondary/Higher Secondary level; To prepare `database on open
          schooling and to conduct online and offline examination of secondary ,
          senior secondary level in all over country and to announce the results
          of concerned examination and release certificates to passed candidates
          time to time; To develop and conduct methodologies practicable to
          languages, including Sanskrit, with innovations; and to promote
          information education in various languages of the country, to provide
          hostels & residential accommodation that may be considered necessary
          for the student & for each member of the staff that may be made
          eligible for it; To establish & maintain institution for the
          handicapped & for adult education, like vocational training in
          vocation of household industry, semi  skilled jobs for
          self-employment, short hand & type  writing, and social science,
          Languages, Fine arts. Crafts, music, painting, modeling, physical
          training etc.; To organize educational and vocational training
          programme with special concern for deprived sections, women/girls and
          unemployment youth to provide new skills, refine/sharpen/up-grade the
          existing skills. To open training camps and workshops for the
          development of arts, plays and culture and raise funds through
          subscriptions, donations, trade to fulfill the aims and objects, to
          publish books, encyclopedias, monographs and study materials; To
          impart free education and cultural training to the poor, helpless,
          handicapped and needy children/students, to establish and maintain
          institutions for adult education with the consent of the concerned
          authorities; To provide the best education available in some of the
          schools in India. Emphasis would be on character building,
          self-discipline& the development of the creative & social faculties.
          The society aims at producing well informed & well assured young
          children just king of children that our country needs. To strive to
          meet changing need of providing comprehensive education to develop
          various facets of personality and to impart education to children on
          the most modern lines & provide an environment congenial to growth &
          development of the children, To arrange & organize the social,
          cultural & educational programmes from time to time. To provide
          professional services to the government and other agencies in the
          field of education, in general, and school education, in particular,
          for the development and growth of distance and open school system and
          develop appropriate curriculum for vocational and continuing education
          to prepare student population for the world of work. To provide the
          best possible teaching/ learning environment to its students, so that
          they can serve the society effectively and with dignity individualized
          study with flexibility in terms of place and duration. To identify
          educational needs of the children/persons of the State who are
          otherwise not catered to by the formal system of school education and
          to open study/academic centers. To provide opportunities for school
          education up to pre-degree level through Open and Distance
          Learning(ODL) mode, to identify and promote standards of learning in
          Open and Distance Learning system. To provide professional services to
          the government and other agencies in the field of education, in
          general, and school education, in particular, for the development and
          growth of distance and open school system and develop appropriate
          curriculum for vocational and continuing education to prepare student
          population for the world of work.
        </p>
      </div>
    </div>
  );
};

export default AimsObjectiveContainer;
